import CitizenshipRenunciationModule from '@features/Consular/components/citizenship-renunciation/CitizenshipRenunciation.Module';
import React from 'react';

const CitizenshipRenunciation = () => {
  return <CitizenshipRenunciationModule />;
};

export default CitizenshipRenunciation;
